module.exports = __webpack_public_path__ + "img/qhPanel.047162b0.png";